interface VoidFunctionComponent<P = {}> {
	(props: P, context?: any): React.ReactElement<any, any> | null;
	propTypes?: React.WeakValidationMap<P> | undefined;
	contextTypes?: React.ValidationMap<any> | undefined;
	defaultProps?: Partial<P> | undefined;
	displayName?: string | undefined;
}

export type VFC<P = {}> = VoidFunctionComponent<P>;

export enum APIResponse {
	SUCCESS = "success",
	FAILED = "failed",
	ERROR = "error",
}

export enum MenuLink {
	PRODUCT_MANAGEMENT = "product-management",
	NON_PARTNER_CLUB = "non_partner_club",
	MIGRATIONS = "migrations",
	PROVIDER_OPERATIONS = "provider_operations",
}

export enum UserRole {
	Recruiter = "ROLE_RECRUITER",
	Admin = "ROLE_ADMIN",
	ClubManager = "ROLE_CLUB_MANAGER",
	Coach = "ROLE_COACH",
}

export enum PlayerPosition {
	ALL = "ALL",
	G = "G",
	DD = "DD",
	DC = "DC",
	DG = "DG",
	MDC = "MDC",
	MC = "MC",
	MOC = "MOC",
	MG = "MG",
	MD = "MD",
	ATT = "ATT",
	AG = "AG",
	AD = "AD",
}

export enum SortDirection {
	ASC = "ASC",
	DESC = "DESC",
}

/** `DOMException.prototype.name` values used in catch blocks (e.g. fetch abort). */
export enum DomExceptionName {
	AbortError = "AbortError",
}